import { connectEventHubsVM, EventHubsContext } from './event-hubs.context';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { EventHubsVM } from './event-hubs.viewmodel';
import { EventHubsPresentation, EventHubsPresentationProps } from './event-hubs.presentation';


const EventHubsContainer = connectEventHubsVM<EventHubsPresentationProps>(EventHubsPresentation, vm => ({ vm: vm }));
export const EventHubs = moduleHost(EventHubsVM, EventHubsContext, EventHubsContainer);